import React, { createContext, useEffect, useRef, useContext, useState } from 'react'
import { OrderEngineContext } from './OrderEngineContext'
import { OkeDeviceContext } from './OkeDeviceContext.js'
import { OkeEcrContext } from './OkeEcrContext'
import { fetchPrograms, fetchTickets } from './attractions/api.js'
import { customAlphabet } from 'nanoid'
const alphabet = '0123456789abcdefghijklmnopqrstuvwxyz'
const nanoid = customAlphabet(alphabet, 16)

const AttractionsContext = createContext()

const AttractionsProvider = ({ children, prefix = 'pos' }) => {
  const { brandID, token } = useContext(OrderEngineContext)
  const { deviceParams } = useContext(OkeDeviceContext)
  const [programs, setPrograms] = useState(localStorage.getItem(`${prefix}.programs`) ? JSON.parse(localStorage.getItem(`${prefix}.programs`)) : null)
  const [tickets, setTickets] = useState(localStorage.getItem(`${prefix}.tickets`) ? JSON.parse(localStorage.getItem(`${prefix}.tickets`)) : null)
  const { addItem, sums, items, payments, addPayment, finalizeReceipt, stornoItem, clearValues } = useContext(OkeEcrContext)
  const fetchedPrograms = useRef(false)
  const fetchedTickets = useRef(false)
  const brandIDRef = useRef(null)
  const tokenRef = useRef(null)

  useEffect(() => {
    if (token && brandID && !fetchedPrograms.current) {
      brandIDRef.current = brandID
      tokenRef.current = token
      fetchedPrograms.current = true
      fetchPrograms(brandIDRef.current, tokenRef.current).then((resPrograms) => {
        if (resPrograms?.success) {
          setPrograms(resPrograms.data)
          fetchTickets(brandIDRef.current, tokenRef.current).then((resTickets) => {
            if (resTickets?.success) {
              fetchedTickets.current = true
              setTickets(resTickets.data)
            }
          })
        }
      })
    }
  }, [token, brandID])

  function addTicket(ticket, count) {
    let tickets = []
    for (let i = 0; i < count; i++) {
      let tick = {
        uid: nanoid()
      }
      tickets.push(tick)
    }
    const item = {
      name: ticket.ticketLabel,
      count: count,
      quantity: 1,
      unit: 'piece',
      price: ticket.ticketPrice,
      type: 0,
      subType: 1,
      vat: ticket.ticketVat,
      vatRegister: deviceParams?.printer?.vat?.ticket?.[ticket.ticketVat] || deviceParams?.printer?.vat?.products?.[ticket.ticketVat] || deviceParams?.printer?.vat?.[item?.vat] || '3',
      itemSizeUUID: null,
      data: {
        ticketUID: ticket.ticketUID,
        tickets
      },
      notes: tickets.map(t => `Jegy: ${t.uid}`)
    }
    addItem(item)
  }

  function refresh() {
    return new Promise((resolve, reject) => {
      fetchPrograms(brandIDRef.current, tokenRef.current).then((resPrograms) => {
        if (resPrograms?.success) {
          setPrograms(resPrograms.data)
          fetchTickets(brandIDRef.current, tokenRef.current).then((resTickets) => {
            if (resTickets?.success) {
              setTickets(resTickets.data)
              resolve({ success: true })
            } else {
              resolve(resTickets)
            }
          }).catch(err => {
            console.error(err)
            resolve({ success: false, message: 'Error fetching tickets' })
          })
        } else {
          resolve(resPrograms)
        }
      }).catch(err => {
        console.error(err)
        resolve({ success: false, message: 'Error fetching programs' })
      })
    })
  }

  function stornoTicket(index) {
    stornoItem(index)
  }

  function addPurchasePayment(payment) {
    addPayment(payment)
  }

  function finalizePurchaseReceipt() {
    finalizeReceipt(1)
  }

  return (
    <AttractionsContext.Provider
      value={{
        programs,
        tickets,
        addTicket,
        stornoTicket,
        items,
        payments,
        sums,
        addPurchasePayment,
        finalizePurchaseReceipt,
        refresh,
        cancel: clearValues
      }}
    >
      {children}
    </AttractionsContext.Provider>
  )
}

export { AttractionsContext, AttractionsProvider }